/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitMotor = createReactComponent("circuit-motor", "IconCircuitMotor", [
  ["path", { d: "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  ["path", { d: "M5 12h-3", key: "svg-1" }],
  ["path", { d: "M19 12h3", key: "svg-2" }],
  ["path", { d: "M10 14v-4l2 2l2 -2v4", key: "svg-3" }]
]);

export { IconCircuitMotor as default };
//# sourceMappingURL=IconCircuitMotor.js.map
